var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"color":"white","opacity":"1"}},[_c('v-container',{staticStyle:{"text-align":"center"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}),_c('p',{staticClass:"pt-2",staticStyle:{"font-size":"14px","color":"#fd8c40"}},[_vm._v(" Caricamento in corso ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }